<template>
  <div>
    <Header>One Time No Ride List</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="mt-3 text-left p-3 bg-gray-100 rounded-md !shadow">
        <SearchForm
          v-model="search.query"
          @search="setSearchQuery"
          @clear="clearAllFilters"/>
        <div class="flex gap-4 flex-wrap pb-3">
          <div class="flex flex-row">
            <div class="rounded-l-md shadow-sm p-2">
              Start
            </div>
            <Input
              label="Start"
              ref="startDateInput"
              class="rounded-md shadow-sm"
              type="date"
              v-model="query.startDate"
            />
          </div>
          <div class="flex flex-row">
            <div class="rounded-l-md shadow-sm p-2">
              End
            </div>
            <Input
              label="End"
              ref="endDateInput"
              class="rounded-md shadow-sm"
              type="date"
              v-model="query.endDate"
            />
          </div>
        </div>
        <div class="flex gap-4 flex-wrap">
          <FilterSelector
            v-for="(filterObj, index) in filterUis"
            :key="index"
            :name="filterObj.name"
            :text="filterObj.text"
            :selectedFilter="selectedFilter[filterObj.name]"
            @setSelectedFilter="setSelectedFilter(filterObj.name, $event)"
            :placeholderText="filterObj.placeholderText"
            :filterOptions="filterOptions[filterObj.name]"
            :optionDisplay="filterObj.option.display">
            <template #text>
              {{ filterObj.text }}
            </template>
            <template #options>
              <option
                v-for="(filterOption, index) in filterOptions[filterObj.name]"
                :key="index"
                :value="filterOption[filterObj.option.value]">
                {{ filterOption[filterObj.option.display] }}
              </option>
            </template>
          </FilterSelector>
        </div>
      </div>
      <div class="flex justify-center pt-4">
        <Pagination :pages="pages" to="/OneTimeNoRideList" />
      </div>
      <div class="mt-6 space-y-2 pb-6">
        <Table>
          <template #columns>
            <th
              v-for="(tableSort, index) in tableSorts"
              :key="index">
              <SortTable
                :name="tableSort.name"
                :disabled="tableSort.disabled"
                :selectedSort="selectedSort"
                @setSelectedSort="selectedSort = $event">
                {{ tableSort.text }}
              </SortTable>
            </th>
          </template>
          <template #rows>
            <OneTimeNoRideItem
              v-for="(item, index) in oneTimeNoRides"
              :key="index"
              :item="item"
              :selected="item.id == selected"
              :isInternal="isInternal"
              @changeSelected="selected = $event"
            />
          </template>
        </Table>
      </div>
      <div class="flex justify-center pb-4" v-if="oneTimeNoRides.length > 0">
        <Pagination :pages="pages" to="/OneTimeNoRideList" />
      </div>
    </Main>
    <div class="fixed bottom-3 left-3 group space-y-2">
      <div
        class="space-y-2"
        :class="{
          hidden: !actionsOpen
        }"
      >
        <button
          type="button"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300"
          @click="$router.push({ name: 'NewRequestForm' })"
        >
          <div
            class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4v16m8-8H4"
              />
            </svg>
          </div>
          <div
            class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
          >
            <div class="text-base text-gray-600 uppercase font-bold">
              Add student
            </div>
          </div>
        </button>
        <button
          type="button"
          :disabled="selected == -1"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
          @click="changeRequestAction"
        >
          <div
            class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
              />
            </svg>
          </div>
          <div
            class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
          >
            <div class="text-base text-gray-600 uppercase font-bold">
              New change request
            </div>
          </div>
        </button>
        <button
          v-if="showOneTimeNoRide()"
          :disabled="selected == -1"
          type="button"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
          @click="noRideAction"
        >
          <div
            class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
              />
            </svg>
          </div>
          <div
            class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
          >
            <div class="text-base text-gray-600 uppercase font-bold">
              One Time No ride
            </div>
          </div>
        </button>
        <button
          type="button"
          :disabled="selected == -1"
          class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300 disabled:!opacity-25"
          @click="studentHistoryAction"
        >
          <div
            class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
          >
            <svg
              class="h-7 w-7 text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 21 21"
            >
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                transform="translate(3 2)"
              >
                <path
                  d="m14.5 12.5v-7l-5-5h-5c-1.1045695 0-2 .8954305-2 2v10c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2z"
                />
                <path d="m8.5 4.5v4h3" />
                <path
                  d="m2.5 2.5c-1.1045695 0-2 .8954305-2 2v10c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2"
                />
              </g>
            </svg>
          </div>
          <div
            class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
          >
            <div class="text-base text-gray-600 uppercase font-bold">
              Student Details
            </div>
          </div>
        </button>
      </div>
      <button
        type="button"
        class="rounded-full bg-gray-300 p-1 flex items-center hover:bg-gray-200 transition-colors duration-300"
        @click="actionsOpen = !actionsOpen"
      >
        <div
          class="rounded-full bg-white h-12 w-12 flex items-center justify-center"
        >
          <svg
            v-if="!actionsOpen"
            xmlns="http://www.w3.org/2000/svg"
            class="h-7 w-7 text-gray-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <svg
            v-if="actionsOpen"
            xmlns="http://www.w3.org/2000/svg"
            class="h-7 w-7 text-gray-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
            />
          </svg>
        </div>
        <div
          class="justify-center items-center px-3 flex-grow hidden group-hover:flex"
        >
          <div class="text-base text-gray-600 uppercase font-bold">
            {{ `${actionsOpen ? 'Hide' : 'Show'} actions` }}
          </div>
        </div>
      </button>
    </div>
  </div>
</template>
<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
.table-row:nth-child(even) {
  background-color: #f2f2f2; /* Even row background color */
}
.table-row:nth-child(odd) {
  background-color: rgba(121, 229, 229, 0.4); /* Odd row background color */
}
</style>
<script>
import Main from '../components/Main.vue'
import Input from '../components/Input.vue'
import Header from '../components/Header.vue'
import OneTimeNoRideItem from '../components/items/OneTimeNoRideItem.vue'
import FilterSelector from '../components/FilterSelector.vue'
import SortTable from '../components/SortTable.vue'
import Table from '../components/Table.vue'
import Pagination from '../components/Pagination.vue'
import SearchForm from '../components/Search/SearchForm.vue'

import oneTimeNoRideListService from '../services/pages/oneTimeNoRideList.js'

import settings from '../services/settings.js'
import user from '../services/user/user.js'
import time from '../services/utils/time.js'
import events from '../services/events.js'
import { forOwn, omit, isEqual, isEmpty } from 'lodash'

export default {
  name: 'StudentList',
  components: {
    Main,
    Input,
    Header,
    OneTimeNoRideItem,
    FilterSelector,
    SortTable,
    Table,
    Pagination,
    SearchForm,
  },
  data() {
    return {
      user: undefined,
      query: {
        search: '',
        filters: '',
        startDate: time.today(),
        endDate: undefined,
      },
      skipWatchQuery: false,
      oneTimeNoRides: [],
      currentSearchQuery: '',
      search: {
        query: ''
      },
      pages: {},
      selected: -1,
      filterOptions: {},
      selectedOneTimeNoRide: {},
      actionsOpen: true,
      isInternal: false,
      selectedSort: {
        name: '',
        descending: false
      },
      selectedFilter: {},
      filterUis: [
        {
          name: 'direction',
          text: 'Direction',
          option: {
            value: 'code',
            display: 'text'
          }
        }
      ],
      tableSorts: [
        {
          name: 'studentId',
          text: 'Student ID',
          disabled: false
        },
        {
          name: 'firstName',
          text: 'First Name',
          disabled: false
        },
        // {
        //   name: 'middleName',
        //   text: 'Middle Name',
        //   disabled: false
        // },
        {
          name: 'lastName',
          text: 'Last Name',
          disabled: false
        },
        {
          name: 'requester',
          text: 'Requester',
          disabled: false
        },
        {
          name: 'relationship',
          text: 'Relationship',
          disabled: true
        },
        {
          name: 'startDate',
          text: 'Start Date',
          disabled: false
        },
        {
          name: 'endDate',
          text: '(Multi) End Date',
          disabled: false
        },
        {
          name: 'direction',
          text: 'Direction',
          disabled: true
        },
      ]
    }
  },
  eventCallbackIds: {},
  methods: {
    async setOneTimeNoRidesData() {
      if (this.loadingData) return
      this.loadingData = true

      try {
        this.user = await user.get()
        if (this.checkUserCanViewPage()) {
          return
        }

      let apiParams = {
        startDate: this.query.startDate,
        endDate: this.query.endDate,
        page: this.$route.query.page,
        sortBy: this.selectedSort.name
          ? (this.selectedSort.descending ? '-' : '') + this.selectedSort.name
          : ''
      }
      let filterQueryParam = ''
      for (const [key, selected] of Object.entries(this.selectedFilter)) {
        if (!isEmpty(selected)) {
          if (filterQueryParam) {
            filterQueryParam += ';'
          }
          filterQueryParam += `${key}=${selected.join(',')}`
        }
      }
      if (filterQueryParam) {
        apiParams['filterBy'] = encodeURIComponent(filterQueryParam)
      }

      if (this.search.query) {
        apiParams['search'] = this.search.query
      }

      const oneTimeNoRidesData = (await oneTimeNoRideListService.getOneTimeNoRideDataFromServer(apiParams)).data
      this.pages = oneTimeNoRidesData.pages
      this.oneTimeNoRides = oneTimeNoRidesData.content

      let selectedItem = this.oneTimeNoRides.find((elem) => {
        return elem.id == this.selected
      })

      if (selectedItem === undefined) {
        this.selected = -1
      }
    } catch (error) {
      console.error('Error fetching OneTimeNoRide data:', error)
    } finally {
      this.loadingData = false
    }
  },
    // async clearFilters() {
    //   this.setStartDateByQuery(time.today())
    //   this.setEndDateByQuery(undefined)
    //   this.setOneTimeNoRidesData()
    // },
    setStartDateByQuery(date) {
      this.query.startDate = date
      this.$refs.startDateInput.$el.value = date
    },
    setEndDateByQuery(date) {
      if (date !== undefined) {
        this.query.endDate = date
        this.$refs.endDateInput.$el.value = date
      }
    },
    setSelectedSortByQuery(name) {
      this.selectedSort.name = name
    },
    setSortDescentingByQuery(value) {
      this.selectedSort.descending = value === 'true'
    },
    setFiltersByQuery(value) {
      if (!value) return
      this.query.filters = value
      const filters = value.split(';')
      filters.forEach(filterSection => {
        const [key, values] = filterSection.split('=')
        this.selectedFilter[key] = values.split(',').map(v => (['district', 'partition'].includes(key) ? parseInt(v) : v))
      })
    },
    setSearchByQuery(value) {
      this.query.search = value
      this.search.query = value
      this.currentSearchQuery = value
    },
    setSearchQuery() {
      // console.log(this.search.query, this.currentSearchQuery)
      let newSearchQuery = this.search.query
      if (newSearchQuery != this.currentSearchQuery) {
        this.query.search = newSearchQuery

        // let queryObj = {
        //   query: {
        //     ...this.$route.query
        //   }
        // }
        // delete queryObj.query.search
        // queryObj.query.search = newSearchQuery

        // this.$router.push(queryObj)
        this.currentSearchQuery = newSearchQuery
        // this.setOneTimeNoRidesData()
      }
    },
    clearAllFilters() {
      events.trigger('clearFilters')
      Object.keys(this.selectedFilter).forEach(key => this.selectedFilter[key] = [])
      this.query.filters = undefined
      this.setSearchQuery()
    },
    getSelectedOneTimeNoRide() {
      return this.oneTimeNoRides.find(item => item.id === this.selected)
    },
    noRideAction() {
      const { db_id, internal_id, student_id, first_name, last_name } = this.selectedOneTimeNoRide.student
      this.$router.push({
        name: 'OneTimeNoRide',
        params: {
          student: {
            dbId: db_id,
            internalId: internal_id,
            studentId: student_id,
            firstName: first_name,
            lastName: last_name
          }
        }
      })
    },
    showOneTimeNoRide() {
      return this.user?.can('submit_one_time_no_ride')
    },
    checkUserCanViewPage() {
      if (!this.user.can('view_one_time_no_ride_list')) {
        this.$router.push({
          name: 'VendorForms'
        })
        return true
      }
      if (this.user.can('view_internal_cst_data')) {
        this.isInternal = true
      }
    },
    changeRequestAction() {
      settings.requestForm.dbId = this.selectedOneTimeNoRide.student.db_id
      this.$router.push({
        name: 'ChangeRequestForm'
      })
    },
    studentHistoryAction() {
      if (this.selected < 0) {
        return
      }

      this.$router.push({
        name: 'StudentHistory',
        params: {
          dbId: this.selectedOneTimeNoRide.student.db_id
        }
      })
    },
    setSelectedFilter(filterName, selectedValues) {
      this.selectedFilter[filterName] = selectedValues
      let filterQueryParam = ''
      for (const [key, selected] of Object.entries(this.selectedFilter)) {
        if (!isEmpty(selected)) {
          if (filterQueryParam) {
            filterQueryParam += ';'
          }
          filterQueryParam += `${key}=${selected.join(',')}`
        }
      }
      this.query.filters = filterQueryParam
      this.updateQuery(this.query)
      this.setOneTimeNoRidesData()
    },
    readAndLoadQueryParams() {
      this.skipWatchQuery = true

      forOwn(this.$route.query, (value, key) => {
        switch (key) {
          case 'startDate':
            this.setStartDateByQuery(value)
            break
          case 'endDate':
            this.setEndDateByQuery(value)
            break
          case 'sortByName':
            this.setSelectedSortByQuery(value)
            break
          case 'sortByDescending':
            this.setSortDescentingByQuery(value)
            break
          case 'filters':
            this.setFiltersByQuery(value)
            break
          case 'search':
            this.setSearchByQuery(value)
            break
        }
      })
      // console.log('Read Load Query', JSON.stringify(this.query))
      this.skipWatchQuery = false
      this.updateQuery(this.query)
    },
    updateQuery(current) {
      let hasChanges = false
      let queryObj = {
        startDate: this.$route.query.startDate,
        endDate: this.$route.query.endDate,
        search: this.$route.query.search,
        filters: this.$route.query.filters,
        ...this.$route.query
      }

      if (current.startDate !== this.$route.query.startDate) {
        hasChanges = true
        queryObj.startDate = current.startDate
      }
      if (current.endDate !== this.$route.query.endDate) {
        hasChanges = true
        queryObj.endDate = current.endDate
      }
      if (current.search !== this.$route.query.search) {
        hasChanges = true
        if (current.search) {
          queryObj.search = current.search
        }
        else {
          delete queryObj.search
        }
      }
      if (current.filters !== this.$route.query.filters) {
        hasChanges = true
        if (current.filters) {
          queryObj.filters = current.filters
        }
        else {
          delete queryObj.filters
        }
      }

      if (hasChanges) {
        if (!isEqual(this.$route.query, queryObj)) {
          this.$router.push({
            query: queryObj
          })
        }
      }
    }
  },
  async created() {
    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }

    if (this.isInternal) {
      this.tableSorts.unshift({
        name: 'internalId',
        text: 'Internal ID',
        disabled: false
      })

      this.filterUis.unshift({
        name: 'district',
        text: 'District',
        option: {
          value: 'id',
          display: 'code'
        }
      })

      this.filterUis.unshift({
        name: 'partition',
        text: 'Partition',
        option: {
          value: 'id',
          display: 'description'
        }
      })
      
      this.filterUis.unshift({
        name: 'schoolYear',
        text: 'School Year',
        option: {
          value: 'code',
          display: 'text'
        }
      })
    }
    if (this.isInternal) {
      const filterOptionsResponse = await oneTimeNoRideListService.getOneTimeNoRideFiltersFromServer()
      const filterOptionsData = filterOptionsResponse.data
      if (filterOptionsData.district) {
        filterOptionsData.district.sort((a, b) => a.name.localeCompare(b.name))
      }
      if (filterOptionsData.partition) {
        filterOptionsData.partition.sort((a, b) => a.description.localeCompare(b.description))
      }
      if (filterOptionsData.schoolYear) {
        filterOptionsData.schoolYear.sort((a, b) => {
          const isAcademicYear = year => /^\d{4}-\d{4}$/.test(year.code)
          const extractStartYear = year => parseInt(year.code.match(/^\d{4}/)?.[0] || 0, 10)

          const aIsAcademic = isAcademicYear(a)
          const bIsAcademic = isAcademicYear(b)
          const aYear = extractStartYear(a)
          const bYear = extractStartYear(b)

          if (aYear !== bYear) return bYear - aYear
          if (aIsAcademic && !bIsAcademic) return -1
          if (!aIsAcademic && bIsAcademic) return 1
          return 0
        })
        filterOptionsData.schoolYear.reverse()
      }
      this.filterOptions = filterOptionsData
    } else {
      this.filterOptions  = {
        'direction': 
          [
            { 'code': 'I', 'text': 'Inbound', }, 
            { 'code': 'O', 'text': 'Outbound', }
          ]
      }
    }
    for (const filterUi of this.filterUis) {
      this.$set(this.selectedFilter, filterUi.name, [])
    }

    this.$options.eventCallbackIds.listPageSettingsUpdate = events.register(
      'listPageSettingsUpdate',
      () => {
        this.setOneTimeNoRidesData()
      }
    )

    this.readAndLoadQueryParams()
    this.$set(this.query, 'search', this.query.search !== undefined ? this.query.search : '')
    this.$set(this.query, 'filters', this.query.filters !== undefined ? this.query.filters : '')
    this.setOneTimeNoRidesData()
  },
  beforeDestroy() {
    events.remove(
      'listPageSettingsUpdate',
      this.$options.eventCallbackIds.listPageSettingsUpdate
    )
  },
  watch: {
    '$route.query': function () {
      // console.log('WATCH, $route.query', JSON.stringify(current))
      this.readAndLoadQueryParams()
      this.setOneTimeNoRidesData()
    },
    selected: function () {
      this.selectedOneTimeNoRide = this.getSelectedOneTimeNoRide()
    },
    selectedSort: {
      handler() {
        let query = omit(this.$route.query, ['sortByName', 'sortByDescending'])
        if (this.selectedSort.name) {
          query.sortByName = this.selectedSort.name
          query.sortByDescending = this.selectedSort.descending
        }
        const queryCompare = {
          ...query,
          sortByDescending: query.sortByDescending ? 'true' : 'false'
        }
        if (!isEqual(this.$route.query, queryCompare)) {
          this.$router.push({
            query: query
          })
        }
      },
      deep: true
    },
    query: {
      handler: function (current) {
        if (this.skipWatchQuery) {
          // console.log('SKIP WATCH, query', JSON.stringify(current))
          return
        }
        // console.log('WATCH, query', JSON.stringify(current))

        this.updateQuery(current)
      },
      deep: true
    },
  }
}
</script>